<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Редактировать мероприятие {{ id_event }}
                <div class="content-inner">
                    <!-- --- --->
                    <div class="header-for-input">Наименование мероприятия</div>
                    <input type="text" class="content-input input_width_50" v-model="event.name" />
                    <!-- --- --->
                    <div class="header-for-input">Корпоративный стандарт</div>
                    <select class="content-input input_width_50" v-model="event.corpstandart_id">
                        <option value="0">Не выбрано</option>
                        <option v-for="cc in corpstandart_list" :key="cc.id" :value="cc.id">{{cc.name}}</option>
                    </select>
                    <!-- --- --->
                    <div class="header-for-input">Оценочная ведомость</div>
                    <select :disabled="isMkShow" class="content-input input_width_50" v-model="event.marking_list_id">
                        <option value="0">Укажить Корпоративный стандарт</option>
                        <option 
                            v-for="mk in markilg_lists_comoany" 
                            :key="mk.id"  
                            v-show="isMkInSelectShow(mk.corpstandart_id)"
                            :value="mk.id"
                            >
                                {{mk.name}}
                            </option>
                    </select>
                    <!-- --- --->
                    <div class="header-for-input">Дата начала</div>
                    <input type="date" class="content-input input_width_50" v-model="event.date_start" />
                    <!-- --- --->
                    <div class="header-for-input">Дата завершения</div>
                    <input type="date" class="content-input input_width_50" v-model="event.date_end" />

                    <div class="btn_main_button" @click="save_event">Сохранить</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'EditEvent',
    props: ['id', 'id_event'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            event: {
                name: '',
                company_id: this.id,
                corpstandart_id: 0,
                date_start: '',
                date_end: '',
                marking_list_id: 0
            },
            corpstandart_list: {},
            markilg_lists_comoany: {}
        }
    },
    methods: {
        isMkInSelectShow(mk_id) {
            if(mk_id == this.event.corpstandart_id)
                return true
            else return false
        },
        corpstandarts() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart/'+this.id)
            .then(response => {
                this.corpstandart_list = response.data.data
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_event() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/event/'+this.id_event+'/show')
            .then(response => {
                this.event = response.data.data
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        save_event() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.patch(process.env.VUE_APP_API_URL + '/api/event/'+this.id_event+'/update', this.event)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        marking_lists() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/marking_list/'+this.id)
            .then(response => {
                this.markilg_lists_comoany = response.data.data
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.corpstandarts()
        this.get_event()
        this.marking_lists()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>